import { PERMISSION } from '@/constants/permission.constant';

export const dashboardRosute = [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/dashborad/DashboardHome.vue'),
    meta: { requiresAuth: false, permissions: [PERMISSION.DEFAULT] },
  },
];
